import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../../common/form';
import Button from '../../themed/button';

class VICustomCoverItemEditForm extends Form {
	state = {
		data: { id: '', name: '' },
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		id: Joi.string().min(3).required().label('Inspection Standard Label'),
		name: Joi.string().min(3).required().label('Inspection Standard Value'),
	};

	static propTypes = {
		onEditCoverItem: PropTypes.func.isRequired,
		onCancelEdit: PropTypes.func.isRequired,
	};

	componentDidMount(): void {
		if (this.props.initialCoverItem) {
			this.setState({ data: this.props.initialCoverItem });
		}
	}

	doSubmit = () => {
		this.props.onEditCoverItem(this.state.data);
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="form-title">Applicable Standards and Criteria</div>

				<div className="divider my-4"></div>

				{this.renderInput({
					type: 'text',
					name: 'id',
					placeholder: 'Enter Inspection Standard',
					label: 'Inspection Standard',
				})}

				<div className="divider my-4"></div>

				{this.renderInput({
					type: 'text',
					name: 'name',
					placeholder: 'Inspection Standard Value',
					label: 'Enter Inspection Standard Value',
				})}

				<div className="d-flex justify-content-end">
					{this.renderButton('Update Inspection Standard')}

					<div className="ms-4">
						<Button
							label="Cancel"
							style={{ backgroundColor: 'red' }}
							onClick={this.props.onCancelEdit}
						/>
					</div>
				</div>
			</form>
		);
	}
}

export default VICustomCoverItemEditForm;
